import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import get from 'lodash/get';

import Button from 'rebook/apps/base/components/Button';
import pluralize from 'rebook/apps/utils/text/pluralize';
import formatCurrency from 'rebook/apps/utils/text/formatCurrency';

import styles from './style.scss';


const subscriptionMapper = {
  1: 'Standard',
  2: 'Premium',
  3: 'Premium',
};

const paymentsTitleMapper = (daysPeriod = null) => {
  return {
    Standard: (<span className={styles.title}>Доступ к классике<br />и бестселлерам от 1 месяца</span>),
    Premium: (<span className={styles.title}>Доступ ко всем книгам<br />и аудиокнигам от 1 месяца</span>),
    Rent: (
      <span className={styles.title}>
        Доступ к этой книге<br />на {daysPeriod} {pluralize(daysPeriod, 'дня', 'дни', 'дней')}
      </span>
    ),
  };
};

const BookPayment = (props) => {
  const { type, subscriptionId, price, bookLink, daysPeriod, handleClick, user } = props;
  const hasTrial = !!get(user, 'has_trial', null);
  const isSubscription = type === 'subscription';
  const subscriptionType = subscriptionMapper[subscriptionId] || 'Rent';
  const paymentsStyles = classNames(
    isSubscription && styles[`subscription${subscriptionType}`],
    !isSubscription && styles[type],
  );
  const formattedPrice = formatCurrency(price, 'RUB');
  const priceText = isSubscription ? `${formattedPrice} / мес` : `${formattedPrice}`;
  const paymentsLink = subscriptionMapper[subscriptionId] === 'Premium'
    ? ((!hasTrial || !user) ? '/trial' : '/payments/?subscription_type=pro')
    : '/payments/?subscription_type=standard';
  const linkUrl = isSubscription ? paymentsLink : `${bookLink}buy_rent/`;

  return (
    <Link to={linkUrl}
      className={classNames(styles.bookPayment, 'swiper-slide', 'jest-link-to-payments')}
      onClick={() => { handleClick(type); }}>
      <div className={paymentsStyles}>
        <div className={styles.paymentInfo}>
          <span className={styles.typeHeader}>
            {isSubscription ? 'Подписка' : 'Аренда книги'}
          </span>
          <div className={styles.price}>
            {priceText}
          </div>
          <div className={styles.title}>
            {paymentsTitleMapper(daysPeriod)[subscriptionType]}
          </div>
          {(subscriptionType === 'Premium' && (!hasTrial || !user)) && (
            <div className={styles.trialText}>
              <span>Первые 14 дней <b>бесплатно</b></span>
            </div>
          )}
        </div>
        {isSubscription && (
          <div className={styles[`image${subscriptionType}`]} />
        )}
      </div>
      <div className={styles.footer}>
        <Button className="jest-book-payments-offer-button">{isSubscription ? 'Оформить' : 'Взять в аренду'}</Button>
      </div>
    </Link>
  );
};

BookPayment.propTypes = {
  type: PropTypes.oneOf(['rent', 'subscription']).isRequired,
  subscriptionId: PropTypes.number,
};

export default BookPayment;

